const BOOKINGS_STORAGE_KEY = "nightStayBookings";
const PENDING_PAYMENT_KEY = "nightStayPendingPayment";
const PAYMENT_RESULT_KEY = "nightStayPaymentResult";

const canUseStorage = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export const parseStorageValue = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn("Failed to parse booking data from storage", error);
    return null;
  }
};

export const loadBookings = () => {
  if (!canUseStorage()) return [];
  const raw = window.localStorage.getItem(BOOKINGS_STORAGE_KEY);
  const parsed = parseStorageValue(raw);
  return Array.isArray(parsed) ? parsed : [];
};

export const saveBookings = (bookings) => {
  if (!canUseStorage()) return;
  window.localStorage.setItem(BOOKINGS_STORAGE_KEY, JSON.stringify(bookings));
};

export const loadPendingPayment = () => {
  if (!canUseStorage()) return null;
  const raw = window.localStorage.getItem(PENDING_PAYMENT_KEY);
  return parseStorageValue(raw);
};

export const savePendingPayment = (payload) => {
  if (!canUseStorage()) return;
  window.localStorage.setItem(PENDING_PAYMENT_KEY, JSON.stringify(payload));
};

export const clearPendingPayment = () => {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(PENDING_PAYMENT_KEY);
};

export const loadPaymentResult = () => {
  if (!canUseStorage()) return null;
  const raw = window.localStorage.getItem(PAYMENT_RESULT_KEY);
  return parseStorageValue(raw);
};

export const savePaymentResult = (payload) => {
  if (!canUseStorage()) return;
  window.localStorage.setItem(PAYMENT_RESULT_KEY, JSON.stringify(payload));
};

export const clearPaymentResult = () => {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(PAYMENT_RESULT_KEY);
};

export const generateBookingId = () => {
  const now = new Date();
  const stamp = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, "0"),
    String(now.getDate()).padStart(2, "0"),
  ].join("");
  const random = String(Math.floor(Math.random() * 10000)).padStart(4, "0");
  return `BK-${stamp}-${random}`;
};

export const storageKeys = {
  bookings: BOOKINGS_STORAGE_KEY,
  pendingPayment: PENDING_PAYMENT_KEY,
  paymentResult: PAYMENT_RESULT_KEY,
};
